import { Button, rem } from "@mantine/core";
import { IconArrowLeft, IconHistory } from "@tabler/icons-react";
import { Fragment } from "react";
import { Notification } from "src/utils/Notification";

import { parseHeadersIntoDoubled } from "../../../../../generator/_Buttons/AddCommentsButton/AddCommentsButton.utils";
import { useConvertLbEntry } from "../../../../../generator/hooks/useConvertLbEntry";
import { type ISection } from "../../../../../interfaces";
import { useDispatch } from "../../../../../redux/hooks";
import { setEditing } from "../../../../../redux/slices/entrySlice";
import {
  ESaveEntryReason,
  setLogbook,
  setSaveReason,
} from "../../../../../redux/slices/generatorSlice";
import { convertToUUIDKeys } from "../../../../../redux/utils/convertToUUIDKeys";
import { Flex } from "../../../../../styled";
import { deepClone } from "../../../../../utils";
import { getRowWithExclusives } from "../../../../../utils/logbookUtils/getRowWithExclusives";
import HistoryModalSection from "./HistoryModalSection";

interface Props {
  section: ISection;
  onNavigateBack: () => void;
}
const HistoryModalGenerator = ({ section, onNavigateBack }: Props) => {
  const dispatch = useDispatch();
  const convertLbEntry = useConvertLbEntry();
  const restoreRow = () => {
    if (
      section.deletedRowIndex === undefined ||
      section.sectionIndex === undefined
    )
      return;

    const convertedLbEntry = JSON.parse(convertLbEntry());
    convertedLbEntry.sections[section.sectionIndex].rows.splice(
      section.deletedRowIndex,
      0,
      deepClone(section.rows[0]),
    );

    const { convertedSections: convertedWithUUIDKeys } = convertToUUIDKeys(
      deepClone(convertedLbEntry.sections),
    );
    const modifiedSection = convertedWithUUIDKeys?.[section.sectionIndex];
    if (!modifiedSection) return;

    convertedWithUUIDKeys[section.sectionIndex].rows[section.deletedRowIndex] =
      getRowWithExclusives(modifiedSection, section.deletedRowIndex, true);

    const newHeaders = parseHeadersIntoDoubled(
      convertedWithUUIDKeys[section.sectionIndex].rows,
      deepClone(convertedWithUUIDKeys[section.sectionIndex].headers),
    );

    convertedLbEntry.sections = convertedWithUUIDKeys;
    convertedLbEntry.sections[section.sectionIndex].headers = newHeaders;

    Notification("Success", "Row restored successfully", "green");
    dispatch(setLogbook(convertedLbEntry.sections));
    dispatch(setEditing(true));
    dispatch(setSaveReason(ESaveEntryReason.restoreRow));
    onNavigateBack();
  };
  return (
    <Fragment>
      <Flex gap={20} align="center">
        <Button
          leftIcon={<IconArrowLeft />}
          variant="outline"
          onClick={onNavigateBack}>
          Go back
        </Button>
        <Button
          leftIcon={<IconHistory />}
          variant="outline"
          onClick={restoreRow}>
          Restore Row
        </Button>
      </Flex>

      <HistoryModalSection section={section} />
    </Fragment>
  );
};
export default HistoryModalGenerator;
